import { IdentifierDTO } from '@zazume/zzm-base';
import { DateVO, PriceVO } from '@zazume/zzm-utils';

import { PaginationOptions } from '#/hooks';
import { BasicUserVO } from '#/models';
import { Payout } from '#/models/Payout';
import { SepaPayments } from '#/models/SepaPayments';

import { doDelete, doGet, parserDataList, toPaginatedURL } from '../../helpers';

const toSepaPayments = (raw: any): SepaPayments =>
  new SepaPayments({
    ...raw,
    paymentsTotal: PriceVO.fromPrimitive(raw.paymentsTotal),
    createdAt: DateVO.fromPrimitive(raw.createdAt),
    basicAuthor: new BasicUserVO({ ...raw.basicAuthor })
  });

export const sepaPayments = {
  delete: (sepaPaymentId: IdentifierDTO) => doDelete<void>(`/dashboard/sepa-payments/${sepaPaymentId}`),
  findPaginated: () => (pagination: PaginationOptions) => () =>
    doGet<SepaPayments[]>(toPaginatedURL('/dashboard/sepa-payments', pagination), parserDataList(toSepaPayments)),
  getLinkedPayouts: (sepaPaymentId: IdentifierDTO) => () =>
    doGet<Payout[]>(`/dashboard/sepa-payments/linked-payouts/${sepaPaymentId}`)
};
